<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <footer class="footer">
      <div class="footer-top">
        <div class="footer-top-container full-box">
          <div class="item-container">
            <div
              class="item"
              v-for="(item,index) in imgList"
              :key="`imgList${index}`"
            >
              <div class="image">
                <img
                  :src='item.image'
                  alt=""
                  width="32"
                  height="37"
                >
              </div>
              <div class="content">{{item.content}}</div>
            </div>
          </div>
          <Divider />
          <div class="details">
            <div class="category">
              <div
                v-for="(categoryItem,index) in enumFooter"
                :key="index"
              >
                <div class="category-title">{{categoryItem.title}}</div>
                <div
                  v-for="(item,cindex) in categoryItem.List"
                  :key="`categoryItem${cindex}`"
                  class="category-item"
                >
                  <div @click="tapItem(item.key)">{{item.name}}</div>
                </div>
              </div>
            </div>
            <div class="qrcode-container">
              <div class="phone">
                <span
                  class="icon iconfont iconphone"
                  style="font-size:24px"
                ></span>
                <span>{{phoneNumber}}</span>
              </div>
              <div class="qrcode">
                <div>
                  <img
                    src="/static/img/footer/gongZhongHao.png"
                    alt=""
                    width="125"
                    height="125"
                  >
                </div>
                <div>
                  <div class='wechat'> <img
                      src="/static/img/footer/wechat.png"
                      alt=""
                      width="27"
                      height="27"
                    ></div>
                  <div class="get-qrcode">扫码关注</div>
                  <div>公众号了解更多</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <!-- <div class="footer-details">危险化学品经营许可证|食品经营许可证|非药品易制毒化学品经营备案证明|第二类医疗器械经营备案凭证</div> -->
        <!--  <div class="footer-details1">
          版权所有：南京鼎阳科技有限公司
        </div>-->
        <!-- <div class="footer-details">Copyright@ dys360.cn 1998-2020 Corporation All Rights Reserved <a href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备20043599号-1</a></div> -->
        <div class="footer-details" v-html="topicInfo.Body"></div>
      </div>
    </footer>
  </div>
</template>

<script>
import '@/styles/components/footer/footer.scss';
import { enumFooter } from '@/utils/enum.js';
import { mapActions } from 'vuex';
const prefix = 'cpt-footer-footer';
export default {
  name: 'Footer',
  data () {
    return {
      prefix,
      enumFooter,
      topicInfo: {},
      imgList: [
        {
          image: '/static/img/footer/zhuan.png',
          content: '专业专注'
        },
        {
          image: '/static/img/footer/ding.png',
          content: '定制专属'
        },
        {
          image: '/static/img/footer/quan.png',
          content: '全国覆盖'
        },
        {
          image: '/static/img/footer/zhi.png',
          content: '智能互联'
        }
      ],
      phoneNumber: ''
    };
  },
  methods: {
    ...mapActions({
      getOnlinePhone: 'getOnlinePhone',
      topicGetByKey: 'topicGetByKey'
    }),
    tapItem (key) {
      if (key === 'CompanyProfile' || key === 'CompanyIntroductionAndServiceIntroduction') {
        this.$router.push({
          path: '/about'
        });
      } else {
        this.$router.push({
          path: '/topic',
          query: {
            key: key
          }
        });
      }
    }
  },
  created () {
    this.getOnlinePhone().then(res => {
      if (res.Success) {
        this.phoneNumber = res.Data;
      }
    });
    this.topicGetByKey('PutOnRecordInfo').then(res => {
      this.topicInfo = res.Data;
    });
  }
};
</script>

<style scoped lang='scss'>
@import '@/styles/base.scss';
/*****************************底 部 开 始*****************************/

/*****************************底 部 结 束*****************************/
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue